import React from 'react';

interface StatusBadgeProps {
  status: string;
}

const statusStyles: Record<string, string> = {
  Completed: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  Success: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  OK: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  Failed: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
  Running: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  PartialFailure: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  PartialError: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  Skipped: 'bg-surface-hover text-muted',
  // Call Transcript Retrieval (Communication.CallTranscript.FetchStatus) — Fetched reuses the
  // positive-outcome green; NoRecording/NoTranscriptAvailable are expected, non-error terminal
  // states (never surfaced as failures) so they get the same neutral treatment as Skipped;
  // Blocked (missing Zoom scope) is deliberately its own amber tone, distinct from Failed's red,
  // so a scope-gap run reads as a different kind of problem than a generic failure at a glance.
  Fetched: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  NoRecording: 'bg-surface-hover text-muted',
  NoTranscriptAvailable: 'bg-surface-hover text-muted',
  NotAttempted: 'bg-surface-hover text-muted',
  Blocked: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const style = statusStyles[status] || 'bg-surface-hover text-primary';
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${style}`}>
      {status}
    </span>
  );
};
